import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider, useApp } from './contexts/AppContext';
import AppLayout from './components/layout/AppLayout';
import LoginPage from './components/LoginPage';
import KeyMetrics from './pages/WeeklyMetrics';
import AccountDashboard from './pages/AccountDashboard';

import Retention from './pages/Retention';
import HubSpotMarketing from './pages/HubSpotMarketing';
import GTMDashboard from './pages/GTMDashboard';


function AppRoutes() {
  const { isAuthenticated, isLoading } = useApp();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin h-10 w-10 border-4 border-gray-200 border-t-eep-navy rounded-full" />
          <p className="text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<KeyMetrics />} />
        <Route path="/key-metrics" element={<KeyMetrics />} />
        <Route path="/retention" element={<Retention />} />
        <Route path="/sales" element={<GTMDashboard />} />
        <Route path="/account-dashboard" element={<AccountDashboard />} />

        <Route path="/marketing" element={<HubSpotMarketing />} />

        <Route path="/callback" element={<div />} />
        <Route path="*" element={<KeyMetrics />} />
      </Routes>
    </AppLayout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </BrowserRouter>
  );
}
